import { Dialog } from '@mui/material';
import React from 'react';
import { ReactComponent as CloseIcon } from "../../../../../../assets/img/svg/CloseIcon.svg"
import AAutoComplete from '../../../common/form-fields-mui/AAutoComplete';
import AButton from '../../../common/form-fields-mui/AButton';
import styles from "./styles.module.scss";
import ALoader from '../../../common/a-loader';


const labelStyle = {
    fontWeight: 600,
    fontSize: '12px',
    color: '#262626'
}

const AddEditConfigDialog = ({
    open,
    form,
    handleForm,
    dropdownData,
    handleClose,
    createUpdateConfigHandler,
    regionChangeHandler,
    buLoading,
    loading
}) => {

    const { allActiveRegions, businessAreas, allActiveCareers, allActiveRoles } = dropdownData;

    return (
        <Dialog
            open={open}
            fullWidth
            maxWidth="md"
        >
            {loading && <ALoader position="fixed" />}
            <div className='p-3'>
                <div className='d-flex justify-content-between'>
                    <h4>EPMR Configs</h4>
                    <CloseIcon onClick={handleClose} />
                </div>

                <div className={styles['dropdown-container']}>
                    <div className={styles['label']}>1. Basic Details</div>

                    <div className={styles['dropdowns']}>
                        <AAutoComplete
                            label='Region*'
                            labelStyle={labelStyle}
                            items={allActiveRegions}
                            handleChange={regionChangeHandler}
                            currentValue={form?.regions}
                            isShowCount
                        />

                        <AAutoComplete
                            label='Business area*'
                            labelStyle={labelStyle}
                            items={businessAreas}
                            handleChange={(val) => handleForm("businessArea", val)}
                            currentValue={form?.businessArea}
                            isShowCount
                            isLoading={buLoading}
                        />

                        <AAutoComplete
                            label='Career'
                            labelStyle={labelStyle}
                            items={allActiveCareers}
                            handleChange={(val) => handleForm("academicCareer", val)}
                            currentValue={form?.academicCareer}
                            isShowCount
                        />

                    </div>

                </div>

                <div className={styles['dropdown-container']}>
                    <div className={styles['label']}>2. Approval Setting</div>

                    <div className={styles['dropdowns']}>
                        <AAutoComplete
                            label='L1 Role*'
                            labelStyle={labelStyle}
                            items={allActiveRoles}
                            handleChange={(val) => handleForm("l1Roles", val)}
                            currentValue={form?.l1Roles}
                            isShowCount
                        />

                        <AAutoComplete
                            label='L2 Role'
                            labelStyle={labelStyle}
                            items={allActiveRoles}
                            handleChange={(val) => handleForm("l2Roles", val)}
                            currentValue={form?.l2Roles}
                            isShowCount
                        />

                        <div />

                    </div>

                </div>

                <AButton
                    variant='primary_filled'
                    className='float-right mt-3'
                    onClick={createUpdateConfigHandler}
                >
                    Save Config
                </AButton>

            </div>
        </Dialog>
    )
}

export default AddEditConfigDialog;